const Header = () => {
	return <h1>Wordle</h1>;
};

export default Header;
